/**
 * This file provides lazy access to reduxStore to break circular dependencies.
 * Files in the reducer chain should import from here instead of store.ts.
 */
import type { Store } from 'redux';
import type { AppState } from './app-state.js';

let _reduxStore: Store<AppState> | null = null;

export const setReduxStore = (store: Store<AppState>) => {
  _reduxStore = store;
};

export const getReduxStore = (): Store<AppState> => {
  if (!_reduxStore) {
    throw new Error('Redux store not initialized. This is likely a circular dependency issue.');
  }
  return _reduxStore;
};
